import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tab-content content-background" }

import {computed, ref} from 'vue';
import WidgetTab from "~/chat/vue/widget/WidgetTab.vue";
import {IWidgetTabParams} from "~/chat/ts/data/ITab";
import {IWidgetTab} from "~/chat/vue/widget/IWidgetTab";
import ContentTabInner from "~/chat/vue/widget/tabs/ContentTabInner.vue";
import {WidgetStore} from "~/chat/ts/store/Widget";


const __default__ = {
    name: "ContentTab"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    tab: {},
    useDefaultCloseHandler: { type: Boolean },
    title: {}
  },
  setup(__props: any) {

let props = __props;

let useCustomCloseHandler = computed(() => {
    let chatTab = WidgetStore.chatTab.value;
    return !props.useDefaultCloseHandler && chatTab && WidgetStore.visibleTabs.value.indexOf(chatTab) > -1 && WidgetStore.closeToOnlineChatAllowed.value;
});

function closeHandler() {
    WidgetStore.selectChatTab();
}

let tabRef = ref<IWidgetTab>();

function onScrollTo(value: number) {
    tabRef.value.scrollTo(value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WidgetTab, {
    ref_key: "tabRef",
    ref: tabRef,
    class: "absolute-full-size",
    "content-tab": "",
    title: _ctx.title ? _ctx.title : _ctx.tab.title,
    "close-handler": _unref(useCustomCloseHandler) ? closeHandler : null,
    "without-padding": _ctx.tab.content ? _ctx.tab.content.withoutPadding : false
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ContentTabInner, {
          tab: _ctx.tab,
          onScrollTo: onScrollTo
        }, null, 8, ["tab"])
      ])
    ]),
    _: 1
  }, 8, ["title", "close-handler", "without-padding"]))
}
}

})